import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { mvs } from 'react-native-size-matters';

import { COLORS } from '../../constants';
import { formatTimeFromSeconds } from '../../helpers/durationParser';
import { useAdjustedFontSize } from '../../hooks/useAdjustedFontSize';
import CustomText from '../CustomText';

export const PlayerProgress = () => {
  const { position, duration } = { position: 30, duration: 282 }; //refresh every second
  const timeFontSize = useAdjustedFontSize(mvs(12));

  const progressPercentage = useMemo(() => {
    if (!position || !duration) {
      return 0;
    }
    return (position / duration) * 100;
  }, [position, duration]);

  return (
    <View style={styles.container}>
      {/* progress bar */}
      <View style={styles.progressContainer}>
        <View style={styles.progressTrack}>
          <View style={[styles.progressFill, { width: `${progressPercentage}%` }]} />
        </View>
      </View>
      {/* time display row */}
      <View style={styles.timeRow}>
        <CustomText
          style={[styles.timeTextLeft, { fontSize: timeFontSize }]}
          weight="Bold"
        >
          {formatTimeFromSeconds(position)}
        </CustomText>
        <CustomText
          style={[styles.timeTextRight, { fontSize: timeFontSize }]}
          weight="SemiBold"
        >
          {formatTimeFromSeconds(duration)}
        </CustomText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    gap: mvs(6),
  },
  progressContainer: {
    width: '100%',
  },
  progressTrack: {
    height: 5,
    backgroundColor: 'rgba(255, 255, 255, 0.40)',
    borderRadius: 30,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: COLORS.WHITE,
    borderRadius: 30,
  },
  timeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  timeTextLeft: {
    color: COLORS.WHITE,
  },
  timeTextRight: {
    color: COLORS.WHITE,
    opacity: 0.7,
  },
});
